import template from './ko-page-title.html';

class PageTitleComponentViewModel
{
	constructor (params)
	{
		this.params = params;
		if (window.current_page_title)
			this.current_page_title = window.current_page_title;
		else
			this.current_page_title = ko.observable();
	}
}

export default {
	name: 'ko-page-title',
	viewModel: PageTitleComponentViewModel,
	module_type: 'ko',
	template: template
};
